module.exports = __webpack_public_path__ + "img/gu_get.4c0983c.png";